import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"

export const fetchTimeZones = createAsyncThunk('timeZones/fetchTimeZones', async ({
                                                                        searchQuery,
                                                                      }, { rejectWithValue }) => {
  try {

    const response = await apiRequest.get('/timeZones')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contacts'
    return rejectWithValue(errorMessage)
  }
})